export default {
	"item.NoInformationWasObtained": "没有获取到信息",
	"item.AGoodThingToShareWithYou": "给你分享了一个好东西",
	"item.LimitedTimeDiscountedPrices": "限时折扣价",
	"item.ThePosterIsBeingGenerated": "正在生成海报",
	"item.rise": "起"
}